import { LandingPage as LandingPageForm } from '@bgea-js/form-templates';
import decisionMagazineHardCopy from "../../../../src/content/decision-magazine-2024 /customConfirmationHardcopy";
import "../../../../src/content/decision-magazine-2024 /decision-magazine.scss";
import * as React from 'react';
export default {
  LandingPageForm,
  decisionMagazineHardCopy,
  React
};